module.exports = __webpack_public_path__ + "static/media/icon-birthday.19d567c3.svg";